import { motion } from "framer-motion";
import { Building2, Cpu, Banknote, ShieldCheck, Users, Gem } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

// Digitally pristine, razor-sharp vector marks (not photoreal renders) drawn in a champagne-gold
// gradient stroke. Frameless so they blend into the surface, with a soft spatial drift for depth.
const MARKERS = [
  { Icon: Building2, label: "Built for UK Hospitality" },
  { Icon: Cpu, label: "AI-Powered Operations" },
  { Icon: Banknote, label: "UK Payroll Ready" },
  { Icon: ShieldCheck, label: "Secure Cloud Infrastructure" },
  { Icon: Users, label: "Designed for Hospitality Teams" },
  { Icon: Gem, label: "Enterprise-Grade Experience" },
];

export const TrustBand = () => (
  <section className="relative" data-testid="trust-band"
    style={{ background: "radial-gradient(130% 100% at 50% 0%, rgba(212,175,55,0.10), rgba(212,175,55,0.02) 42%, transparent 70%), linear-gradient(180deg, #17140E 0%, #131109 55%, #0E0C08 100%)" }}>
    {/* Shared gold gradient for every icon stroke — keeps the marks perfectly crisp at any resolution */}
    <svg width="0" height="0" className="absolute" aria-hidden="true">
      <defs>
        <linearGradient id="trustGold" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FBF0C9" />
          <stop offset="38%" stopColor="#E9CE7A" />
          <stop offset="70%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#A8842A" />
        </linearGradient>
      </defs>
    </svg>
    <style>{`.trust-ico svg{stroke:url(#trustGold);}`}</style>

    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14 grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-8 sm:gap-y-10">
      {MARKERS.map((m, i) => (
        <motion.div
          key={m.label}
          data-testid="trust-marker"
          className="group flex items-center gap-3 sm:gap-4"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: EASE, delay: i * 0.09 }}>
          <motion.div
            className="trust-ico shrink-0 relative flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 transition-transform duration-500 group-hover:scale-110"
            style={{ willChange: "transform" }}>
            {/* soft gold aura for depth, no hard box */}
            <span className="absolute inset-0 rounded-2xl pointer-events-none"
              style={{ background: "radial-gradient(60% 60% at 50% 40%, rgba(212,175,55,0.16), transparent 70%)" }} />
            <m.Icon
              className="relative w-8 h-8 sm:w-9 sm:h-9"
              strokeWidth={1.5}
              style={{ filter: "drop-shadow(0 3px 10px rgba(212,175,55,0.32))" }} />
          </motion.div>
          <span className="text-sm sm:text-[15px] text-white/75 leading-snug font-medium group-hover:text-white transition-colors duration-300">{m.label}</span>
        </motion.div>
      ))}
    </div>
  </section>
);
